
































































helpers = require '../../helpers.coffee'

view_model = {
  components:
    listItem: require '../users/list_item.vue'
    draggable: require 'vuedraggable'

  props:
    modalTitle: { required: true }
    kind: { required: true }

  data: ->
    users: []
    selected_all: false
    selected_users: []
    current_user: Session.current_user
    company_id: Session.current_company.id
    removed: []
    draggable_options: { disabled: Session.current_user.isSeller() }
    carousel:
      type: Carousel
    loading_users: true
    loading_carousel: true

  computed:
    loading: ->
      @loading_users || @loading_carousel

    has_last_user: ->
      !(@carousel.last_user instanceof Array) && !jQuery.isEmptyObject(@carousel.last_user)

  methods:
    changeOrder: (data) ->
      @selected_users = data
      @reorderCarousel()

    reorderCarousel: ->
      len = @selected_users.length
      if len > 0
        j = 0
        while j < len-1
          @selected_users[j].next_user_id = @selected_users[j+1].user_id
          j++
        @selected_users[len-1].next_user_id = @selected_users[0].user_id
        @carousel.next_user_id = @selected_users[0].user_id

    userIsSelected: (user) ->
      for selected in @selected_users
        return true if selected.user_id == user.id
      false

    indexOfUser: (user) ->
      for selected, index in @selected_users
        return index if selected.user_id == user.id

    selectAll: ->
      @selected_all = !@selected_all
      for user in @users
        if @selected_all
          if !@userIsSelected(user)
            @selectUser(user)
        else
          @selectUser(user)

    selectUser: (user) ->
      if @userIsSelected(user)
        users = @selected_users.map (selected) -> selected.user
        index = @indexOfUser(user)
        if @selected_users[index].id?
          @removed[@selected_users[index].user_id] = @selected_users[index]
        @selected_users.splice(index,1)
        @reorderCarousel()
        @selected_all = false
      else
        if @removed[user.id]?
          carousel_user = @removed[user.id]
          delete @removed[user.id]
        else
          carousel_user = new CarouselUser
        carousel_user.user_id = user.id
        carousel_user.next_user_id =  if @selected_users.length > 0 then @selected_users[0].user_id else user.id
        carousel_user.user = user
        @selected_users.push carousel_user
        @reorderCarousel()
        @selected_all = @selected_users.length == @users.length

    loadData: ->
      @loadUsers()
      @loadCarousel()

    loadUsersSuccess: (data) ->
      @users = data.users.filter (user) -> !user.isAdmin()
      @users = data.users
      @loading_users = false

    loadUsers: ->
      @loading_users = true
      params = {q: {accepted: true, s: 'name asc'}}
      params['company_id'] = @company_id if @current_user.isAdmin()
      new UsersResource().index(@loadUsersSuccess, @unknownError, {params})

    loadCarousel: (data) ->
      if data
        @carousel = data.carousel
        @selected_users = data.carousel.carousel_users
      else
        @loading_carousel = true
        new CarouselResource().show(@loadCarouselSuccess, @loadCarouselFailure, params: { @kind })

    loadCarouselSuccess: (data) ->
      @selected_users = data.carousel.carousel_users
      @carousel = data.carousel
      @loading_carousel = false
      @selected_all = @selected_users.length == @users.length

    loadCarouselFailure: (data) ->
      if data.status == 404
        @carousel = new Carousel
        @loading_carousel = false
      else
        @unknownError

    buildCarousel: ->
      carousel = new Carousel(kind: @kind)
      carousel.type = 'Carousel' if @kind == 'rd'
      carousel.next_user_id = if @selected_users.length > 0 then @selected_users[0].user_id else null
      for selected in @selected_users
        carousel.carousel_users.push(
          new CarouselUser(
            id: selected.id,
            user_id: selected.user_id,
            next_user_id: selected.next_user_id
          )
        )
      if Object.keys(@removed).length > 0
        for user_removed in Object.values(@removed)
          carousel.carousel_users.push (
            new CarouselUser(
              id: user_removed.id,
              user_id: user_removed.user_id,
              next_user_id: user_removed.next_user_id
              _destroy: true
            )
          )
      carousel

    save: ->
      carousel = @buildCarousel().serialize()
      new CarouselResource().create_or_update(@saveSuccess, @saveFailure, carousel)

    saveSuccess: (data) ->
      @loadCarousel(data)
      @removed = []
      jQuery('#carousel-config').modal('hide')
      @$emit 'savedCarousel', data.carousel
      alertify.success this.$t('integrations.label.modal_carousel.successFeedback')

    saveFailure: (data) ->
      alertify.error this.$t('integrations.label.modal_carousel.failFeedback')
}
exports.default = helpers.vue_include(view_model, helpers.form)



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/configuration/modal_carousel.vue